function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, message, Button, Divider, Form, Tabs, Modal } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { Download, Cash, CheckCircleFill, ArrowClockwise, BuildingFillGear, XCircleFill, PeopleFill, ArrowLeftRight, CartCheckFill, ExclamationSquareFill } from "react-bootstrap-icons";
import CompanyBills from "../components/CompanyBills";
import InsBills from "../components/InsBills";
import Moment from "react-moment";
import UserBills from "../components/UserBills";
import dayjs from 'dayjs';
import Autorisations from "../components/Autorisations";
import Refund from "./forms/Refund";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var TabPane = Tabs.TabPane;
var confirm = Modal.confirm;
var Loans = function Loans() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    listOfBills = _useState2[0],
    setListOfBills = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    expenses = _useState4[0],
    setExpenses = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    loansAr = _useState6[0],
    setLoansAr = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    billsArrayData = _useState8[0],
    setBillsArrayData = _useState8[1];
  var _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState0[0],
    setIsDataLoading = _useState0[1];
  var _useState1 = useState(moment().startOf('month').format()),
    _useState10 = _slicedToArray(_useState1, 2),
    from = _useState10[0],
    setFrom = _useState10[1];
  var _useState11 = useState(moment().endOf('month').format()),
    _useState12 = _slicedToArray(_useState11, 2),
    to = _useState12[0],
    setTo = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showRefund = _useState14[0],
    setShowRefund = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedTransaction = _useState16[0],
    setSelectedTransaction = _useState16[1];
  var handleApproveLoan = function handleApproveLoan(t) {
    setSelectedTransaction(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous l'approbation de la demande ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["D\xE9caissement de ", t.amount.toLocaleString("Fr"), " GNF \xE0 la demande de ", t.user.lastname, " ", t.user.firstname]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approvetransaction", {
          transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Ok!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleRejectLoan = function handleRejectLoan(t) {
    setSelectedTransaction(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Voulez-vous vraiment rejeter la demande ?"
      }),
      content: /*#__PURE__*/_jsx("p", {
        children: "Rejet de la demande de sortie sous forme de pret"
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "rejecttransaction", {
          transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Ok!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY HH:mm",
        date: date
      });
    },
    key: "date"
  }, {
    title: "Demandeur",
    dataIndex: "user",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "patient"
  }, {
    title: "Montant (GNF)",
    dataIndex: "amount",
    key: "aount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: "Motif",
    dataIndex: "comment",
    key: "comment",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: function render(text) {
      return /*#__PURE__*/_jsxs("b", {
        children: [text == 0 && /*#__PURE__*/_jsx("span", {
          style: {
            color: "#DAB48E"
          },
          children: "En attente de validation"
        }), text == 1 && /*#__PURE__*/_jsx("span", {
          style: {
            color: "#9CC487"
          },
          children: "Approuv\xE9"
        }), text == 2 && /*#__PURE__*/_jsx("span", {
          style: {
            color: "#C48774"
          },
          children: "Annul\xE9"
        })]
      });
    }
  }, {
    title: "",
    dataIndex: "action",
    key: "action",
    render: function render(t) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            handleApproveLoan(t);
          },
          style: {
            color: "#34C482"
          },
          disabled: t.status == 1,
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(CheckCircleFill, {
              size: 25
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            handleRejectLoan(t);
          },
          style: {
            color: "#C46D4E"
          },
          disabled: t.status == 0 || t.status == 2,
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(ArrowClockwise, {
              size: 25
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            handleRejectLoan(t);
          },
          style: {
            color: "#C4725C"
          },
          disabled: t.status == 1 || t.status == 2,
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(XCircleFill, {
              size: 25
            })
          })
        })]
      });
    }
  }];
  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };
  var onSearchFinish = function onSearchFinish(values) {
    setListOfBills([]);
    setBillsArrayData([]);
    setFrom(moment(new Date(values.range[0]._d)).format());
    setTo(moment(new Date(values.range[1]._d)).format());
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getloans/" + moment(new Date(from)).format() + "/" + moment(new Date(to)).format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setLoansAr([]);
        setExpenses(response.data.loans);
        response.data.loans.forEach(function (e) {
          setLoansAr(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: e.id,
              date: e.created_at,
              user: e.user.firstname + " " + e.user.lastname,
              amount: e.amount.toLocaleString("Fr"),
              status: e.status,
              comment: e.comment,
              action: e
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue " + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [from, to]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Form, {
            size: "large",
            onFinish: onSearchFinish,
            layout: "horizontal",
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "range",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(RangePicker, {
                  ranges: rangePresets,
                  showTime: {
                    format: 'HH:mm'
                  },
                  format: "DD-MM-YYYY HH:mm"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "RECHERCHE"
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: handleExport,
                  style: {
                    background: "#34C482"
                  },
                  icon: /*#__PURE__*/_jsx(Download, {
                    size: 28
                  }),
                  children: /*#__PURE__*/_jsx("b", {
                    children: "EXPORTER"
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
            style: {
              fontWeight: "bold",
              fontStyle: 'italic'
            },
            children: ["Du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
          }), /*#__PURE__*/_jsx(Table, {
            size: "small",
            columns: cols,
            bordered: true,
            sticky: true,
            loading: isDataLoading,
            dataSource: loansAr,
            pagination: true
          })]
        })
      })
    }), selectedTransaction && /*#__PURE__*/_jsx(Modal, {
      footer: null,
      width: "550px",
      open: showRefund,
      onCancel: function onCancel() {
        setShowRefund(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(Refund, {
        handler: function handler() {}
      })
    })]
  });
};
export default Loans;